import store from "../../store";
import router from "../../router";
import Account from "./account";
import ValueMapper from "../common/value-mapper";

const RESOLVE_TYPE_LOGOUT = "logout";
const RESOLVE_TYPE_SYSTEM_ERROR = "system-error";

/**
 * エラー時のコンテンツ
 */
class ApiErrorContents {
  _status = 0;
  _message = "";
  _resolveType = "";

  constructor(status, message, resolveType) {
    this._status = status;
    this._message = message;
    this._resolveType = resolveType;
  }

  /**
   * ステータスコード
   */
  get status() {
    return this._status;
  }

  /**
   * エラーメッセージ
   */
  get message() {
    return this._message;
  }

  /**
   * 基本処理：例外を投げてログアウトする
   */
  throwLogout() {
    Account.signOut(store, router);
  }

  /**
   * 基本処理：例外を投げてシステムエラーに遷移する
   */
  throwSystemError() {
    router.push("/error");
  }

  /**
   * エラーを基本処理で解決する
   * 処理種別に応じて処理を実行する
   */
  resolve() {
    if (this._resolveType == RESOLVE_TYPE_LOGOUT) {
      this.throwLogout();
    }
    if (this._resolveType == RESOLVE_TYPE_SYSTEM_ERROR) {
      this.throwSystemError();
    }
  }
}

class ApiError {
  // リクエストパラメータが誤っている
  get badRequest() {
    return new ApiErrorContents(400, "Bad Request", RESOLVE_TYPE_SYSTEM_ERROR);
  }

  // 認証トークンが切れている、認証されていない
  get unauthorized() {
    return new ApiErrorContents(401, "Unauthorized", RESOLVE_TYPE_LOGOUT);
  }

  // 権限のないリクエストを実行した
  get forbidden() {
    return new ApiErrorContents(403, "Forbidden", RESOLVE_TYPE_SYSTEM_ERROR);
  }

  // 定義されていないリクエストを実行した
  get notFound() {
    return new ApiErrorContents(404, "Not Found", RESOLVE_TYPE_SYSTEM_ERROR);
  }

  // サーバエラー
  get serverError() {
    return new ApiErrorContents(500, "Server Error", RESOLVE_TYPE_SYSTEM_ERROR);
  }

  /**
   * エラーメッセージから500エラーを作成する
   */
  fromMessage(status, message) {
    return new ApiErrorContents(status, message, RESOLVE_TYPE_SYSTEM_ERROR);
  }

  /**
   * ステータスコードをエラーオブジェクトに変換する
   * @param {ステータスコード} status
   * @returns ApiErrorContents
   */
  fromStatus(status) {
    return ValueMapper.map({
      400: this.badRequest,
      401: this.unauthorized,
      403: this.forbidden,
      404: this.notFound,
      500: this.serverError,
    }).getOrElse(status, this.fromMessage(status, "Unknown Reason"));
  }
}

export default new ApiError();
